import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  archiveRequest,
  getRequestById,
  getResponseByRequest,
} from '../../../services/requestEndPoints';
import {
  getNotificationByRequest,
  sendRemindAll,
  sendRemindByAgency,
} from 'services/notificationEndPoints';
import { RequestData } from 'interfaces/request.interface';
import { IResponsesDB } from 'interfaces/response.interface';
import apiFetch from 'services/apiFetch';
import { INotifications } from 'interfaces/notification.interface';

export const fetchRequestById = createAsyncThunk('requestDetail/fetchById', async (id: string) => {
  try {
    const endpoint = getRequestById(id);
    const response = await apiFetch<RequestData>(endpoint).then((res) => res?.data || null);
    if (response) return response;
    else Error('Something went wrong!');
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    console.log('fetchRequestById catch:', message);
    throw Error(message);
  }
});

export const fetchResponsesByRequest = createAsyncThunk(
  'requestDetail/fetchResponses',
  async (id: string) => {
    try {
      const endpoint = getResponseByRequest(id);
      const response = await apiFetch<IResponsesDB[]>(endpoint).then((res) => res?.data || null);
      if (response) return response;
      else Error('Something went wrong!');
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('fetchResponses catch:', message);
      throw Error(message);
    }
  },
);

export const fetchRequests = createAsyncThunk('requestDetail/requests', async (id: string) => {
  try {
    const endpoint = getNotificationByRequest(id);
    const requests = await apiFetch<INotifications[]>(endpoint).then((res) => res.data || []);
    console.log('fetchRequests requests:', JSON.stringify(requests));
    return requests;
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    console.log('fetchRequests catch:', message);
    throw Error(message);
  }
});

export const execArchiveRequest = createAsyncThunk(
  'requestDetail/archive',
  async (data: { id: string }) => {
    try {
      const endpoint = archiveRequest(data);
      return await apiFetch<RequestData>(endpoint).then((res) => res?.data || null);
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('archiveRequest catch:', message);
      throw Error(message);
    }
  },
);

export const remindAgency = createAsyncThunk(
  'requestDetail/remind',
  async (payload: { requestId: string; agencyId: string }) => {
    try {
      const { requestId, agencyId } = payload;
      const endpoint = sendRemindByAgency(requestId, agencyId);
      const response = await apiFetch<string>(endpoint).then((res) => res?.data || null);
      if (response && response === 'Success') return response;
      else return Error('Notification failed');
    } catch (error) {
      let message = 'Something went wrong!';
      if (error instanceof Error) message = error.message;
      else {
        if (typeof error === 'object' && error !== null) {
          if ('message' in error) {
            message = String(error.message);
          }
        }
      }
      console.log('remindAgency catch:', message);
      throw Error(message);
    }
  },
);

export const remindAll = createAsyncThunk('requestDetail/remindAll', async (requestId: string) => {
  try {
    const endpoint = sendRemindAll(requestId);
    const response = await apiFetch<string>(endpoint).then((res) => res?.data || null);
    if (response && response === 'Success') return response;
    else return Error('Notification failed');
  } catch (error) {
    let message = 'Something went wrong!';
    if (error instanceof Error) message = error.message;
    else {
      if (typeof error === 'object' && error !== null) {
        if ('message' in error) {
          message = String(error.message);
        }
      }
    }
    console.log('remindAgency catch:', message);
    throw Error(message);
  }
});
